import { z } from 'zod';

/**
 * Покупка энергии. Либо произвольная сумма в центах USD (минимум $0.50 у PayPal),
 * либо `packageId` из каталога — тогда сумму и энергию назначает сервер, а
 * `amountUsdCents` (клиент шлёт цену пакета для удобства) игнорируется.
 */
export const CreatePaymentOrderInput = z.object({
  amountUsdCents: z.number().int().min(50).max(100_000_000),
  packageId: z.string().min(1).max(64).optional(),
  email: z.email().optional(),
});
export type CreatePaymentOrderInput = z.infer<typeof CreatePaymentOrderInput>;

/**
 * Пустую строку из формы трактуем как «не передано»: для create поле опционально,
 * для update — «не менять». Непустые значения валидируем `min(1)`.
 */
const emptyAsUndefined = z.preprocess(
  (v) => (typeof v === 'string' && v.trim() === '' ? undefined : v),
  z.string().min(1).optional(),
);

/** Admin: создание/редактирование провайдера. Все секреты опциональны
 *  (webhookId можно задать позже — после регистрации вебхука в PayPal);
 *  обязательность clientId/clientSecret при создании проверяется в сервисе. */
export const AdminUpsertProviderInput = z.object({
  type: z.enum(['PAYPAL', 'LAVATOP']),
  name: z.string().min(1).max(120),
  mode: z.enum(['sandbox', 'live']),
  isActive: z.boolean().default(true),
  // PayPal
  clientId: emptyAsUndefined,
  clientSecret: emptyAsUndefined,
  webhookId: emptyAsUndefined,
  // LavaTop
  apiKey: emptyAsUndefined,
  webhookSecret: emptyAsUndefined,
  offerEnergy10: emptyAsUndefined,
  offerEnergy20: emptyAsUndefined,
  offerEnergy50: emptyAsUndefined,
  /** Оффер продукта «Pro + промо» ($250) в кабинете LavaTop. */
  offerProPromo: emptyAsUndefined,
});
export type AdminUpsertProviderInput = z.infer<typeof AdminUpsertProviderInput>;

/** Admin: привязка города к провайдеру. */
export const AdminUpsertCityProviderInput = z.object({
  cityId: z.uuid(),
  providerId: z.uuid(),
  priority: z.number().int().min(0).default(0),
  isActive: z.boolean().default(true),
});
export type AdminUpsertCityProviderInput = z.infer<typeof AdminUpsertCityProviderInput>;
